import React from 'react';
import { HtmlViewer } from '../viewer/html-viewer.js';
import 'ricos-context';
import 'wix-rich-content-common';
import '../Iframe-a53e6164.js';
import '../dataHooks.js';
import '../defaults.js';
import '../htmlFixer.js';
import '../IframeHtml.js';
import 'prop-types';
import '../IframeUrl.js';

const Html = ({ settings, componentData }) => {
  return /* @__PURE__ */ React.createElement(HtmlViewer, { componentData, iframeSandboxDomain: "", settings });
};

export { Html };
//# sourceMappingURL=component.js.map
